<template>
  <div class="wrapper">
    <Sidebar />
    <div class="main-panel">
      <Navbar />
      <div class="content">
        <router-view />
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default {
  components: {
    Sidebar,
    Navbar,
    Footer
  }
};
</script>
